import { useNavigate } from 'react-router-dom';
import strategyArrow from '../../../assets/icons/check-in/strategy-arrow.svg';

interface CheckInNavBarProps {
  label: string;
  to?: string; // If provided, navigate to this path instead of going back
}

export default function CheckInNavBar({ label, to }: CheckInNavBarProps) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (to) {
      navigate(to);
    } else {
      navigate(-1);
    }
  };

  return (
    <button
      onClick={handleBack}
      className="flex items-center gap-2 px-4 mt-4 w-full max-w-md lg:max-w-xl mx-auto"
    >
      <img src={strategyArrow} alt="" width={24} height={24} style={{ transform: 'scaleX(-1)' }} />
      <span
        className="text-xs font-black uppercase text-[#1B2831]"
        style={{ fontFamily: 'DM Sans', letterSpacing: '0.72px' }}
      >
        {label}
      </span>
    </button>
  );
}
